<template>
  <div class="text-left">
    <div class="col-12 col-sm-8 px-0 pt-5">
      <h1 class="pt-5 heading">The Hospitality</h1>
      <h1 class="sub-heading">Gift Finder</h1>
      <p class="pt-3 body-text">
      If time is money, then spend money on a time they'll love. Get together with the gift of the best restaurants, bars, pubs, cafes and hotels
      </p>
      <p class="pt-2 info-text">
        Every brand here is powered by <a href="https://usetoggle.com" target="_blank">usetoggle.com</a>
      </p>
    </div>
  </div>
</template>
<script>

export default {
  name: "Intro"
};
</script>

<style scoped>
@font-face {
   font-family: 'Manrope';
   src: url('../assets/fonts/Manrope.ttf') format('truetype');
   font-style: normal;
 }

 @font-face {
   font-family: 'Manrope-ExtraBold';
   src: url('../assets/fonts/Manrope-ExtraBold.ttf') format('truetype');
   font-style: normal;
 }

.heading {
  font-family: 'Manrope-ExtraBold';
  color: #B91818;
  font-size: 52px;
  font-weight: 800;
  margin: 0;
}
.sub-heading {
  font-family: 'Manrope-ExtraBold';
  color: #B91818;
  font-size: 30px;
  font-weight: bolder;
}
.body-text {
  font-family: 'Manrope-ExtraBold';
  color: #042750;
  font-size: 20px;
  font-weight: 800;
}

.info-text, a {
  font-family: 'Manrope';
  color: #6E7F95;
  font-size: 10px;
  font-weight: 400;
  margin-bottom: 45px;
}

a {
  text-decoration: underline;
}

@media (max-width: 1120px){
  .body-text {
    width: 90%;
  }
  .info-text, a {
    margin-bottom: 11px;
  }
  .heading {
    font-size: 45px;
  }
}
</style>